
import { calculateAdditiveTaxes, getTaxesType , calculateInclusiveTaxes} from "../yoello-lib/modules/utils/TaxController";
import { ITaxType } from "../yoello-lib/modules/interfaces/ITaxes";
export function generateExtrasPricingOption(item: any, hideExclusive: boolean,formatCurrency:(price:number)=>string) {
    let extra_pricing_options: any = {};
    const taxType = getTaxesType(item.item_taxes);
    if (taxType === ITaxType.INCLUSIVE) {
        if (item.pricing_options_extras) {
            for (const priceOps in item.pricing_options_extras) {
                const data = item.pricing_options_extras[priceOps];
                const price = calculateInclusiveTaxes(item.item_taxes!, data.option_price) - data.option_price ;
                extra_pricing_options[priceOps] = { ...data, 
                    option_price: formatCurrency(data.option_price as number),
                    option_price_exclusive:formatCurrency(-price)
                }; 
            }
        }
    } else {
        const taxes = item.item_taxes;
        if (item.pricing_options_extras) {
            for (const priceOps in item.pricing_options_extras) {
                const data = item.pricing_options_extras[priceOps];
                const price = calculateAdditiveTaxes(taxes, data.option_price) + data.option_price;
                extra_pricing_options[priceOps] = {
                    ...data,
                    option_price: formatCurrency(price),
                    option_price_exclusive: formatCurrency(data.option_price)
                };
            }
        }
    }

    return extra_pricing_options;
}